import React, { useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";
import PublicShell, { P } from "@/components/PublicShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, CheckCircle2 } from "lucide-react";

// Public account-deletion page (deep-linked from the iPhone app and the App Store listing)
export default function Leave() {
  const [f, setF] = useState({ email: "", password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState("");
  const [err, setErr] = useState("");
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try { const { data } = await axios.post(`${API}/auth/leave-by-credentials`, f); setDone(data.message); }
    catch (ex) { setErr(ex.response?.data?.detail || "Could not process the request"); } finally { setBusy(false); }
  };
  return (
    <PublicShell eyebrow="Delete my account" title="Leave the Vessel" subtitle="Your account is deactivated at once and you are signed out everywhere. For 30 days an officer can restore you if you change your mind; after that your personal details are erased for good. Your past posts stay in the brotherhood's record as “Departed Brother”." testid="leave-page">
      {done ? (
        <p className="mt-8 flex items-start gap-2 rounded-xl border border-emerald-500/40 bg-emerald-500/10 p-4 text-sm" data-testid="leave-done"><CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" />{done}</p>
      ) : (
        <form onSubmit={submit} className="mt-8 max-w-md space-y-4" data-testid="leave-form">
          <div><Label>E-mail</Label><Input type="email" required value={f.email} onChange={set("email")} className="mt-1 border-white/20 bg-white/5 text-white" data-testid="leave-email-input" /></div>
          <div><Label>Password</Label><Input type="password" required value={f.password} onChange={set("password")} className="mt-1 border-white/20 bg-white/5 text-white" data-testid="leave-password-input" /></div>
          <div><Label>Type LEAVE to confirm</Label><Input required value={f.confirm} onChange={set("confirm")} placeholder="LEAVE" className="mt-1 border-white/20 bg-white/5 text-white" data-testid="leave-confirm-input" /></div>
          {err && <p className="text-sm text-red-400" data-testid="leave-error">{err}</p>}
          <Button type="submit" disabled={busy || f.confirm.trim().toUpperCase() !== "LEAVE"} className="bg-destructive text-white hover:bg-destructive/90" data-testid="leave-submit-button">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Deactivate my account"}</Button>
        </form>
      )}
      <P>Signed in already? You can also do this from Profile &amp; Security → Leave the Vessel.</P>
    </PublicShell>
  );
}
